import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=381883f6&scoped=true&"
var script = {}
import style0 from "./Agreement.vue?vue&type=style&index=0&id=381883f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381883f6",
  null
  
)

export default component.exports